module.exports = __webpack_public_path__ + "img/navitas_icon.f95b11d7.png";